import { getApolloClient } from '../lib/getApolloClient';
import { handleGraphQLErrors } from '../util/graphqlError.util';
import {
  BULK_SUBMIT_MISSING_TIMESHEETS,
  GET_MISSING_TIMESHEETS,
} from './missingTimesheet.gql';
import type {
  BulkSubmitMissingTimesheetsInput,
  BulkSubmitMissingTimesheetsResult,
  MissingTimesheet,
} from './missingTimesheet.types';

/** Scheduled shifts not yet submitted, between two `YYYY-MM-DD` dates inclusive. */
const getMissingTimesheets = async (
  tenantId: string,
  startDate: string,
  endDate: string,
  clientId?: string,
): Promise<MissingTimesheet[]> => {
  const { data } = await getApolloClient().query<{
    getMissingTimesheets: { items: MissingTimesheet[] };
  }>({
    query: GET_MISSING_TIMESHEETS,
    variables: {
      tenantId,
      startDate,
      endDate,
      ...(clientId && { clientId }),
    },
    fetchPolicy: 'network-only',
  });
  return data.getMissingTimesheets?.items ?? [];
};

const bulkSubmitMissingTimesheets = async (
  input: BulkSubmitMissingTimesheetsInput,
): Promise<BulkSubmitMissingTimesheetsResult> => {
  const { data, errors } = await getApolloClient().mutate<{
    bulkSubmitMissingTimesheets: BulkSubmitMissingTimesheetsResult;
  }>({
    mutation: BULK_SUBMIT_MISSING_TIMESHEETS,
    variables: { input },
  });
  handleGraphQLErrors(errors, 'Unable to submit timesheets.');
  if (!data?.bulkSubmitMissingTimesheets) {
    throw new Error('Bulk timesheet submission returned no data');
  }
  return data.bulkSubmitMissingTimesheets;
};

export const missingTimesheetActions = {
  getMissingTimesheets,
  bulkSubmitMissingTimesheets,
};
